<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <h1 style="font-weight: 700;font-size: 1.25rem; line-height: 1.75rem;">{{ title }}</h1>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :selected-data="selectedTipoCap" :table-columns="tableColumns" :collection-data="collectionData" :auth-token="authToken" :list-api="listApi" @updateValues="setupUpdateValues" :updatePermission="'update_caps'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import TableComponent from "@/layouts/main/TableComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import {useLayoutMain} from "@/layouts/main";

export default {
  name: 'TipoCapsCRUD',
  components: {
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
  },
  data: function () {
    return {
      Object: Object,
      title: 'Tipo Caps',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Tipo CAP'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de Creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedTipoCap = ref({
      id: '',
      nombre: '',
      estado: ''
    });
    const loadDataCap = ref({
      tipoCap: ''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_TIPO_CAP_CREATE,
      list: process.env.VUE_APP_NEST_TIPO_CAP_FINDALL,
      update: process.env.VUE_APP_NEST_TIPO_CAP_UPDATE,
      updateState: process.env.VUE_APP_NEST_TIPO_CAP_UPDATESTATE
    });
    const {
      paginate,
      queries,
      setupUpdateValues
    } = await useLayoutMain(view, collectionData, authToken, selectedTipoCap, loadDataCap, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedTipoCap,
      loadDataCap,
      listApi,
      paginate,
      queries,
      setupUpdateValues
    };
  }
}
</script>